module.exports = __webpack_public_path__ + "img/pesanan.efd2dd7c.svg";